module.exports = __webpack_public_path__ + "img/denmark-flag-round-small.51b10994.png";